var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M15.068 28.8203C15.3632 28.9925 15.5108 29.0786 15.7191 29.1233C15.8808 29.158 16.1166 29.158 16.2783 29.1233C16.4866 29.0786 16.6342 28.9925 16.9294 28.8203C19.5268 27.305 26.6654 22.5451 26.6654 16.0005V9.62395C26.6654 8.55793 26.6654 8.02492 26.491 7.56675C26.337 7.162 26.0867 6.80085 25.7618 6.51452C25.394 6.1904 24.895 6.00325 23.8968 5.62894L16.7478 2.94804C16.4706 2.8441 16.332 2.79212 16.1894 2.77152C16.0629 2.75324 15.9345 2.75324 15.808 2.77152C15.6654 2.79212 15.5268 2.8441 15.2496 2.94804L8.10057 5.62894C7.10243 6.00325 6.60336 6.1904 6.23558 6.51452C5.91067 6.80085 5.6604 7.162 5.50638 7.56675C5.33203 8.02492 5.33203 8.55793 5.33203 9.62395V16.0005C5.33203 22.5451 12.4706 27.305 15.068 28.8203Z",
    fill: "#5834A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 10.0005L13.332 14.0005L18.6654 16.6671L14.6654 20.6671M26.6654 16.0005C26.6654 22.5451 19.5268 27.305 16.9294 28.8203C16.6342 28.9925 16.4866 29.0786 16.2783 29.1233C16.1166 29.158 15.8808 29.158 15.7191 29.1233C15.5108 29.0786 15.3632 28.9925 15.068 28.8203C12.4706 27.305 5.33203 22.5451 5.33203 16.0005V9.62395C5.33203 8.55793 5.33203 8.02492 5.50638 7.56675C5.6604 7.162 5.91067 6.80085 6.23558 6.51452C6.60336 6.1904 7.10243 6.00325 8.10057 5.62894L15.2496 2.94804C15.5268 2.8441 15.6654 2.79212 15.808 2.77152C15.9345 2.75324 16.0629 2.75324 16.1894 2.77152C16.332 2.79212 16.4706 2.8441 16.7478 2.94804L23.8968 5.62894C24.895 6.00325 25.394 6.1904 25.7618 6.51452C26.0867 6.80085 26.337 7.162 26.491 7.56675C26.6654 8.02492 26.6654 8.55793 26.6654 9.62395V16.0005Z",
    stroke: "#5834A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldZap);
export default __webpack_public_path__ + "static/media/shield-zap.d8db6527d2c372c9540ca79f04f95275.svg";
export { ForwardRef as ReactComponent };